import { render, staticRenderFns } from "./OptionSummary.vue?vue&type=template&id=2ce0a236&scoped=true"
import script from "./OptionSummary.vue?vue&type=script&lang=js"
export * from "./OptionSummary.vue?vue&type=script&lang=js"
import style0 from "./OptionSummary.vue?vue&type=style&index=0&id=2ce0a236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce0a236",
  null
  
)

export default component.exports